import DomainMaps from '@/maps/domainMaps'

const { appDomain: domain } = DomainMaps

const API = {
  // 是否展示小红点(有未读消息)
  GET_SHOW_RED_POINT: `${domain}/zzopen/hunter_market/haveNotRead`,
  GET_FIRSTSCREEN_DATA: `${domain}/zzopen/ypofflinemart/hunterHomePage`, // 获取首页首屏数据
  GET_HUNTER_HOME_PAGE: `${domain}/zzopen/ypofflinemart/hunterHomePageV2`, // 获取首页首屏数据新
  GET_HUNTER_HOME_PAGE_CONFIG: `${domain}/zzopen/ypofflinemart/homePageConfig`, // 获取首页首屏数据-小程序改版专用
  GET_USERSTATUS_DATA: `${domain}/zzopen/ypofflinemart/checkPostRights`, // 获取用户是否签约，用于底部button发布按钮
  GET_ACT_BANNER: `${domain}/zzopen/ypofflinemart/hunterHomePagePopup`, // 获取首页活动弹窗
  GET_CHECK_IN_DATA: `${domain}/zzopen/hunterpub/signDialogForBm`, // 开放入驻 - 首页弹窗接口
  GET_RED_PACKET_DATA: `${domain}/zzopen/ypofflinemart/homePageLogonRedPacketPopup`, // 红包到账 - 首页弹窗接口
  GET_SHOPPING_CART_COUNT: `${domain}/zzopen/ypofflinemart/getMyShoppingCartInfo`, // 获购物车数据
  GET_GEO_POSITION: `${domain}/zzopen/geolibrary/geoposition`, // 获取城市id
  DEL_PRODUCT_INTO_CART: `${domain}/zz/transfer/del`, // 移出购物车
  GET_REDPACK_SUMMARY: `${domain}/zzopen/ypofflinemart/redPackSummary`, // 一口价红包汇总
  GET_REDPACK_NOT_BROWSE: `${domain}/zzopen/ypofflinemart/getNowNotBrowsedRedPacketNum`, // 获取当前用户未浏览的红包数量】
  GET_REDPACK_POP_WINDOW: `${domain}/zzopen/ypofflinemart/redPackPopWindow`, // 红包弹窗接口
  CLOSE_TIP: `${domain}/zzopen/ypofflinemart/closeTopTagContent`, // 关闭提示
  GET_UESER_BEHAVIOR: `${domain}/zzopen/hunter_market/savePageShareLog` // 获取用户行为
}

export default API
